import { useRef } from "react";
import { SPECIAL_OFFERS_LIST } from "../common/Helper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay } from "swiper/modules";
import {
  ActivitiesIcon,
  FlightIcon,
  HotelIcon,
  OfferLeftArrow,
  OfferRightArrow,
  StarIcon,
  TransferIcon,
} from "../common/Icons";
import Title from "../common/Title";

const BestOffers = () => {
  const swiperRef = useRef(null);

  return (
    <div className="pb-[120px] max-lg:pb-20 max-xl:px-4 max-w-[1920px] mx-auto">
      <div className="container 2xl:max-w-[1240px] px-5 mx-auto relative flex items-center justify-between pb-[50px] max-md:pb-10 max-sm:flex-col max-sm:gap-10">
        <Title
          text={"Special Offers / Deals"}
          myClass={"text-left max-md:text-center"}
        />
        <div className="flex items-center gap-3 max-md:hidden">
          <button
            className="size-[48px] flex items-center justify-center border border-[#FF5858] bg-white hover:bg-[#FF5858] transition-all duration-300 rounded-full group"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <OfferLeftArrow className={"group-hover:stroke-white"} />
          </button>
          <button
            className="size-[48px] flex items-center justify-center border border-[#FF5858] bg-white hover:bg-[#FF5858] transition-all duration-300 rounded-full group"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <OfferRightArrow className={"group-hover:stroke-white"} />
          </button>
        </div>
      </div>

      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        speed={1200}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 3.9 },
        }}
        pagination={false}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {SPECIAL_OFFERS_LIST.map((item, index) => (
          <SwiperSlide key={index}>
            <div className=" mx-auto p-4 border border-black/10 rounded-[16px]">
              <img
                src={item.image}
                alt="offer"
                className="pointer-events-none rounded-[12px] w-full h-[224px] object-cover"
              />
              <div className="flex items-center justify-between pt-6">
                <p className="font-medium leading-[100%] text-[#010101] text-[22px]">
                  {item.place}
                </p>
                <div className="flex items-center">
                  <StarIcon />
                  <p className="font-medium leading-[100%] text-[#010101] text-[22px]">
                    {item.rating}
                  </p>
                </div>
              </div>
              <p className="text-black/50 ff-sans text-base leading-[100%] pt-[10px]">
                {item.dayNight}
              </p>
              <div className="flex items-center gap-9 max-sm:gap-7 justify-center pt-6">
                <div className="flex flex-col items-center justify-center gap-[13.28px]">
                  <FlightIcon />
                  <p className="text-[#363636] text-[12px] leading-[100%] font-semibold">
                    {item.flights}
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center gap-[13.28px]">
                  <HotelIcon />
                  <p className="text-[#363636] text-[12px] leading-[100%] font-semibold">
                    {item.hotel}
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center gap-[13.28px]">
                  <TransferIcon />
                  <p className="text-[#363636] text-[12px] leading-[100%] font-semibold">
                    {item.transfer}
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center gap-[13.28px]">
                  <ActivitiesIcon />
                  <p className="text-[#363636] text-[12px] leading-[100%] font-semibold">
                    {item.activities}
                  </p>
                </div>
              </div>
              <ul className="ff-sans text-base leading-[100%] text-black/50 list-disc pl-6 pt-6 pb-6">
                <li>{item.para1}</li>
                <li className="pt-2">{item.para2}</li>
                <li className="pt-2">{item.para3}</li>
              </ul>
              <div className="flex items-baseline gap-5 max-md:gap-3">
                <p className="font-medium text-[22px] max-md:text-xl leading-[100%] line-through">
                  ₹{item.originalPrize}
                </p>
                <div className="flex items-baseline gap-1">
                  <p className="font-medium text-[22px] leading-[100%]">
                    ₹{item.sellingPrize}
                  </p>
                  <p className="ff-sans text-sm leading-[100%] text-black/50">
                    Per person
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="md:hidden flex items-center justify-center pt-10">
        <div className="flex items-center gap-3">
          <button
            className="size-[48px] flex items-center justify-center border border-[#FF5858] bg-white hover:bg-[#FF5858] transition-all duration-300 rounded-full group"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <OfferLeftArrow className={"group-hover:stroke-white"} />
          </button>
          <button
            className="size-[48px] flex items-center justify-center border border-[#FF5858] bg-white hover:bg-[#FF5858] transition-all duration-300 rounded-full group"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <OfferRightArrow className={"group-hover:stroke-white"} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BestOffers;
